/**
 * Decode JWT payload (base64url-safe).
 * @param {string|null|undefined} token
 * @returns {object|null}
 */
export function decodeJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  try {
    const part = token.split(".")[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

/**
 * Resolve tenant user_type from localStorage and JWT.
 * Prefer JWT when present — `user_type` key is not always set on older sessions
 * (e.g. admin → restaurant magic login).
 */
export function getTenantUserType() {
  try {
    const token = localStorage.getItem("token");
    const payload = decodeJwtPayload(token);
    const fromJwt = String(
      payload?.user?.user_type || payload?.user_type || ""
    ).toLowerCase();
    if (fromJwt) return fromJwt;
  } catch {
    /* ignore */
  }

  try {
    const stored = String(localStorage.getItem("user_type") || "").toLowerCase();
    if (stored) return stored;
  } catch {
    /* ignore */
  }

  try {
    const rawUser = localStorage.getItem("user");
    if (rawUser) {
      const parsed = JSON.parse(rawUser);
      const fromUser = String(parsed?.user_type || "").toLowerCase();
      if (fromUser) return fromUser;
    }
  } catch {
    /* ignore */
  }

  return "";
}

export function isCompanyTenantUser() {
  return getTenantUserType() === "company";
}
